let instance = null;

export const setLenis = (l) => {
  instance = l;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (instance) instance.scrollTo(el, { offset: -76 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const scrollTop = () => {
  if (instance) instance.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
};
